import { z } from 'zod';
import api from '~/utils/api';
import { uniqueId } from '~/utils/compute';
import { makeCrewClaimLoader, redirect } from '~/utils/routing';

const paramsSchema = z.object({
  store: z.string().min(1),
  idFromPlatform: z.string().min(1),
  claimType: z.string().min(1),
  shopNowId: z.string().min(1),
});

export const { loader, useLoaderData } = makeCrewClaimLoader(
  async ({ context: { settings }, params }, appStore) => {
    const { store, idFromPlatform, shopNowId } = paramsSchema.parse(params);

    return api
      .fetchShopNowSession({
        params: { storefrontId: settings.storefrontId, shopNowId },
      })
      .then((session) => {
        appStore.dispatch(
          appStore.actions.crewClaim.setShopNowReplacementItems(
            session.lineItems,
          ),
        );

        return {
          lineItems: session.lineItems.map((item) => ({
            ...item,
            gid: uniqueId(),
          })),
        };
      })
      .catch(() => redirect(`/${store}/order/${idFromPlatform}`));
  },
);
